import script from "./RegisterModalContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./RegisterModalContent.vue?vue&type=script&setup=true&lang=ts"

import "./RegisterModalContent.vue?vue&type=style&index=0&id=63f395c8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63f395c8"]])

export default __exports__